import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";

export type ChatbotRenameModalAction = "confirm" | "cancel";

export function useEmitChatbotRenameModalEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    (action: ChatbotRenameModalAction) => {
      emitUserInteractionEvent({
        accountId,
        interactionName: UserInteractionName.ChatbotRenameModal,
        optionSelected: action,
      });
    },
    [accountId],
  );

  return { emit };
}
